export default function modal() {
  return { open: false, show() { this.open = true; }, close() { this.open = false; } };
}
